/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * MoSale Configurator
 * MoSale Endpoint for Configurator 
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://127.0.0.1/restv1/".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * a Avesco contact person. Product manager (less specific) or salesman (more specific).
 * @export
 * @interface AvescoContact
 */
export interface AvescoContact {
    /**
     * name of the contact
     * @type {string}
     * @memberof AvescoContact
     */
    name: string;
    /**
     * the phone number of the contact - should be rendered as hyperlink tel
     * @type {string}
     * @memberof AvescoContact
     */
    phone: string;
    /**
     * optional URL to a portrait of the contact. The portrait is a 128x128 jpg
     * @type {string}
     * @memberof AvescoContact
     */
    portraiturl?: string;
    /**
     * email of the contact - should be rendered as hyperlink - ideally the subject should contain some information about the contaxt of the inquiry (e.g. machine name)
     * @type {string}
     * @memberof AvescoContact
     */
    email: string;
}

/**
 * 
 * @export
 * @interface ConfiguratorProduct
 */
export interface ConfiguratorProduct {
    /**
     * the salesman to be contacted for information about the product - can be null or missing - if this is not null, it must be shown, and the productmanager be hidden.
     * @type {AvescoContact}
     * @memberof ConfiguratorProduct
     */
    salesman?: AvescoContact;
    /**
     * the product manager to be contacted for information about the product - shown if no specific salesman can be determined
     * @type {AvescoContact}
     * @memberof ConfiguratorProduct
     */
    productmanager: AvescoContact;
    /**
     * the division to nearest for a division
     * @type {number}
     * @memberof ConfiguratorProduct
     */
    divisionroundtonearest?: number;
    /**
     * the standard discount to be applied to the total price. 250000 is 25%, 1000000 is 100%
     * @type {number}
     * @memberof ConfiguratorProduct
     */
    standarddiscount: number;
    /**
     * 
     * @type {ConfiguratorProductSpecialdiscount}
     * @memberof ConfiguratorProduct
     */
    specialdiscount?: ConfiguratorProductSpecialdiscount;
    /**
     * possibly empty or null, contains the list of possible quick coupler systems, quick couplers and their buckets
     * @type {Array&lt;ConfiguratorProductQuickcouplers1&gt;}
     * @memberof ConfiguratorProduct
     */
    quickcouplers: Array<ConfiguratorProductQuickcouplers1>;
    /**
     * a list of documents about this product. to be displayed, with a document icon, to be displayed alongside the spinsets
     * @type {Documents}
     * @memberof ConfiguratorProduct
     */
    documents?: Documents;
    /**
     * a array, possibly empty or null, containing objects with data of the spinsets
     * @type {Array&lt;ConfiguratorProductSpinsets&gt;}
     * @memberof ConfiguratorProduct
     */
    spinsets: Array<ConfiguratorProductSpinsets>;
    /**
     * a array, possibly empty or null, containing showroom objects. They should be opened in a new window.
     * @type {Array&lt;ConfiguratorProductShowrooms&gt;}
     * @memberof ConfiguratorProduct
     */
    showrooms: Array<ConfiguratorProductShowrooms>;
    /**
     * a array, possibly empty or null, containing URLs to extra images of this product.
     * @type {Array&lt;string&gt;}
     * @memberof ConfiguratorProduct
     */
    additionalimages: Array<string>;
    /**
     * 
     * @type {ConfiguratorProductMinrentpermonth}
     * @memberof ConfiguratorProduct
     */
    minrentpermonth?: ConfiguratorProductMinrentpermonth;
    /**
     * 
     * @type {ConfiguratorProductMinleasingpermonth}
     * @memberof ConfiguratorProduct
     */
    minleasingpermonth?: ConfiguratorProductMinleasingpermonth;
    /**
     * 
     * @type {ConfiguratorProductFullservice}
     * @memberof ConfiguratorProduct
     */
    fullservice?: ConfiguratorProductFullservice;
    /**
     * 
     * @type {ConfiguratorProductExtendedwarranty}
     * @memberof ConfiguratorProduct
     */
    extendedwarranty?: ConfiguratorProductExtendedwarranty;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProduct
     */
    id: number;
    /**
     * name of the product
     * @type {Nameml}
     * @memberof ConfiguratorProduct
     */
    nameml: Nameml;
    /**
     * a list of base configurations for this product
     * @type {Array&lt;ConfiguratorProductTypes&gt;}
     * @memberof ConfiguratorProduct
     */
    types: Array<ConfiguratorProductTypes>;
    /**
     * a list of categories for the options
     * @type {Array&lt;ConfiguratorProductCategories&gt;}
     * @memberof ConfiguratorProduct
     */
    categories: Array<ConfiguratorProductCategories>;
    /**
     * the possible initial payments in % for the leasing
     * @type {Array&lt;number&gt;}
     * @memberof ConfiguratorProduct
     */
    leasinginitialpayments?: Array<number>;
    /**
     * the possible duration in months for the leasing
     * @type {Array&lt;number&gt;}
     * @memberof ConfiguratorProduct
     */
    leasingdurationmonths?: Array<number>;
    /**
     * 
     * @type {Array&lt;ConfiguratorProductAlternativeproducts&gt;}
     * @memberof ConfiguratorProduct
     */
    alternativeproducts?: Array<ConfiguratorProductAlternativeproducts>;
    /**
     * a list of used equipment similar to this product
     * @type {Array&lt;ConfiguratorProductAlternativeused&gt;}
     * @memberof ConfiguratorProduct
     */
    alternativeused: Array<ConfiguratorProductAlternativeused>;
}

/**
 * 
 * @export
 * @interface ConfiguratorProductAlternativeproducts
 */
export interface ConfiguratorProductAlternativeproducts {
    /**
     * 
     * @type {ConfiguratorProductPrice4}
     * @memberof ConfiguratorProductAlternativeproducts
     */
    price: ConfiguratorProductPrice4;
    /**
     * a URL pointing to a catalogue image of the product. Can return 404, the client must provide a placeholder.
     * @type {string}
     * @memberof ConfiguratorProductAlternativeproducts
     */
    iconurl: string;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductAlternativeproducts
     */
    alternativeproductid: number;
    /**
     * name of the alternative model
     * @type {Nameml}
     * @memberof ConfiguratorProductAlternativeproducts
     */
    nameml: Nameml;
}

/**
 * 
 * @export
 * @interface ConfiguratorProductAlternativeused
 */
export interface ConfiguratorProductAlternativeused {
    /**
     * the brand name
     * @type {string}
     * @memberof ConfiguratorProductAlternativeused
     */
    brand: string;
    /**
     * the type name of the machine
     * @type {string}
     * @memberof ConfiguratorProductAlternativeused
     */
    type: string;
    /**
     * an array of extra images URLs. The URLs listed in this array should be called lazily, only when needed.
     * @type {Array&lt;string&gt;}
     * @memberof ConfiguratorProductAlternativeused
     */
    extraimages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductAlternativeused
     */
    usedequipmentid: number;
    /**
     * 
     * @type {ConfiguratorProductPrice5}
     * @memberof ConfiguratorProductAlternativeused
     */
    price: ConfiguratorProductPrice5;
    /**
     * 
     * @type {ConfiguratorProductUsedequipmentpdfdatasheeturl}
     * @memberof ConfiguratorProductAlternativeused
     */
    usedequipmentpdfdatasheeturl: ConfiguratorProductUsedequipmentpdfdatasheeturl;
    /**
     * a URL pointing to a photograph of the used equipment from the front left
     * @type {string}
     * @memberof ConfiguratorProductAlternativeused
     */
    usedequipmentfrontleftimageurl: string;
}

/**
 * a bucket
 * @export
 * @interface ConfiguratorProductBuckets
 */
export interface ConfiguratorProductBuckets {
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductBuckets
     */
    bucketid: number;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductBuckets
     */
    name?: string;
    /**
     * 
     * @type {ConfiguratorProductPrice1}
     * @memberof ConfiguratorProductBuckets
     */
    price: ConfiguratorProductPrice1;
    /**
     * 
     * @type {ConfiguratorProductTitleml}
     * @memberof ConfiguratorProductBuckets
     */
    titleml: ConfiguratorProductTitleml;
    /**
     * 
     * @type {ConfiguratorProductDescriptionml}
     * @memberof ConfiguratorProductBuckets
     */
    descriptionml: ConfiguratorProductDescriptionml;
}

/**
 * 
 * @export
 * @interface ConfiguratorProductCategories
 */
export interface ConfiguratorProductCategories {
    /**
     * maps the typeid to the multilingual default description of this category
     * @type {any}
     * @memberof ConfiguratorProductCategories
     */
    defaultdescriptionsml: any;
    /**
     * the list of options
     * @type {Array&lt;ConfiguratorProductOptions&gt;}
     * @memberof ConfiguratorProductCategories
     */
    options: Array<ConfiguratorProductOptions>;
    /**
     * the numeric identifier of the category
     * @type {number}
     * @memberof ConfiguratorProductCategories
     */
    categoryid: number;
    /**
     * the sort position of the category. Categories must be sorted by ascending position
     * @type {number}
     * @memberof ConfiguratorProductCategories
     */
    position: number;
    /**
     * if set to true, the user can select at most one option in this category
     * @type {boolean}
     * @memberof ConfiguratorProductCategories
     */
    singleselection: boolean;
    /**
     * name of the category
     * @type {Nameml}
     * @memberof ConfiguratorProductCategories
     */
    nameml: Nameml;
}

/**
 * multilingual description
 * @export
 * @interface ConfiguratorProductDescriptionml
 */
export interface ConfiguratorProductDescriptionml {
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductDescriptionml
     */
    de?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductDescriptionml
     */
    en?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductDescriptionml
     */
    fr?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductDescriptionml
     */
    it?: string;
}

/**
 * multilingual description
 * @export
 * @interface ConfiguratorProductDescriptionml1
 */
export interface ConfiguratorProductDescriptionml1 {
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductDescriptionml1
     */
    de?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductDescriptionml1
     */
    en?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductDescriptionml1
     */
    fr?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductDescriptionml1
     */
    it?: string;
}

/**
 * the possible selection for the extended warranty. The user may selected a combination of duration and type. May be null.
 * @export
 * @interface ConfiguratorProductExtendedwarranty
 */
export interface ConfiguratorProductExtendedwarranty {
    /**
     * lists the incompatible warranty types and durations
     * @type {Array&lt;any&gt;}
     * @memberof ConfiguratorProductExtendedwarranty
     */
    invalid: Array<any>;
    /**
     * the allowed duration of the extended warranty
     * @type {Array&lt;number&gt;}
     * @memberof ConfiguratorProductExtendedwarranty
     */
    durationmonths: Array<number>;
    /**
     * the types of warranty
     * @type {Array&lt;ConfiguratorProductExtendedwarrantyWarrantytypes&gt;}
     * @memberof ConfiguratorProductExtendedwarranty
     */
    warrantytypes: Array<ConfiguratorProductExtendedwarrantyWarrantytypes>;
}

/**
 * 
 * @export
 * @interface ConfiguratorProductExtendedwarrantyWarrantytypes
 */
export interface ConfiguratorProductExtendedwarrantyWarrantytypes {
    /**
     * the key identifying this warranty type
     * @type {string}
     * @memberof ConfiguratorProductExtendedwarrantyWarrantytypes
     */
    key?: string;
    /**
     * the german name
     * @type {string}
     * @memberof ConfiguratorProductExtendedwarrantyWarrantytypes
     */
    de?: string;
    /**
     * the italian name
     * @type {string}
     * @memberof ConfiguratorProductExtendedwarrantyWarrantytypes
     */
    it?: string;
    /**
     * the french name
     * @type {string}
     * @memberof ConfiguratorProductExtendedwarrantyWarrantytypes
     */
    fr?: string;
    /**
     * the english name
     * @type {string}
     * @memberof ConfiguratorProductExtendedwarrantyWarrantytypes
     */
    en?: string;
}

/**
 * describes the possible duration of a full service. May be null.
 * @export
 * @interface ConfiguratorProductFullservice
 */
export interface ConfiguratorProductFullservice {
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductFullservice
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductFullservice
     */
    minhoursperyear: number;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductFullservice
     */
    maxhoursperyear: number;
}

/**
 * the cheapest possible rate per month of leasing. Can be null.
 * @export
 * @interface ConfiguratorProductMinleasingpermonth
 */
export interface ConfiguratorProductMinleasingpermonth {
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductMinleasingpermonth
     */
    CHF?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductMinleasingpermonth
     */
    EUR?: number;
}

/**
 * the cheapest possible rate per month of rent. If missing, the section must not be shown.
 * @export
 * @interface ConfiguratorProductMinrentpermonth
 */
export interface ConfiguratorProductMinrentpermonth {
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductMinrentpermonth
     */
    CHF?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductMinrentpermonth
     */
    EUR?: number;
}

/**
 * an option
 * @export
 * @interface ConfiguratorProductOptions
 */
export interface ConfiguratorProductOptions {
    /**
     * 
     * @type {ConfiguratorProductPrice3}
     * @memberof ConfiguratorProductOptions
     */
    price: ConfiguratorProductPrice3;
    /**
     * the currency code of the price
     * @type {string}
     * @memberof ConfiguratorProductOptions
     */
    currency: string;
    /**
     * multilingual description of the option
     * @type {any}
     * @memberof ConfiguratorProductOptions
     */
    descriptionml: any;
    /**
     * the id of the property
     * @type {number}
     * @memberof ConfiguratorProductOptions
     */
    optionid: number;
    /**
     * the multilingual title of the option
     * @type {any}
     * @memberof ConfiguratorProductOptions
     */
    titleml: any;
}

/**
 * can be null. price keyed by currency code.
 * @export
 * @interface ConfiguratorProductPrice
 */
export interface ConfiguratorProductPrice {
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice
     */
    CHF?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice
     */
    EUR?: number;
}

/**
 * price keyed by currency code
 * @export
 * @interface ConfiguratorProductPrice1
 */
export interface ConfiguratorProductPrice1 {
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice1
     */
    CHF?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice1
     */
    EUR?: number;
}

/**
 * the price of this type, mapped by currency
 * @export
 * @interface ConfiguratorProductPrice2
 */
export interface ConfiguratorProductPrice2 {
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice2
     */
    CHF?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice2
     */
    EUR?: number;
}

/**
 * the option price, keyed by currency
 * @export
 * @interface ConfiguratorProductPrice3
 */
export interface ConfiguratorProductPrice3 {
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice3
     */
    CHF?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice3
     */
    EUR?: number;
}

/**
 * the price of this alternative, keyed by currency
 * @export
 * @interface ConfiguratorProductPrice4
 */
export interface ConfiguratorProductPrice4 {
    /**
     * the price in CHF
     * @type {number}
     * @memberof ConfiguratorProductPrice4
     */
    CHF?: number;
    /**
     * the price in GBP
     * @type {number}
     * @memberof ConfiguratorProductPrice4
     */
    GBP?: number;
}

/**
 * the price, keyed by currency. If null present, the configurator should display Price on Request
 * @export
 * @interface ConfiguratorProductPrice5
 */
export interface ConfiguratorProductPrice5 {
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice5
     */
    CHF?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductPrice5
     */
    EUR?: number;
}

/**
 * a quickcoupler
 * @export
 * @interface ConfiguratorProductQuickcouplers
 */
export interface ConfiguratorProductQuickcouplers {
    /**
     * the unique identifier of this quickcoupler
     * @type {number}
     * @memberof ConfiguratorProductQuickcouplers
     */
    quickcouplerid?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductQuickcouplers
     */
    name?: string;
    /**
     * 
     * @type {ConfiguratorProductPrice}
     * @memberof ConfiguratorProductQuickcouplers
     */
    price?: ConfiguratorProductPrice;
    /**
     * the list of buckets compatible with this quick coupler
     * @type {Array&lt;ConfiguratorProductBuckets&gt;}
     * @memberof ConfiguratorProductQuickcouplers
     */
    buckets?: Array<ConfiguratorProductBuckets>;
    /**
     * 
     * @type {ConfiguratorProductTitleml1}
     * @memberof ConfiguratorProductQuickcouplers
     */
    titleml?: ConfiguratorProductTitleml1;
    /**
     * 
     * @type {ConfiguratorProductDescriptionml1}
     * @memberof ConfiguratorProductQuickcouplers
     */
    descriptionml?: ConfiguratorProductDescriptionml1;
}

/**
 * a quickcoupler and its buckets
 * @export
 * @interface ConfiguratorProductQuickcouplers1
 */
export interface ConfiguratorProductQuickcouplers1 {
    /**
     * the id of the quickcoupler system
     * @type {number}
     * @memberof ConfiguratorProductQuickcouplers1
     */
    quickcouplersystemid: number;
    /**
     * the name of the quickcoupler system
     * @type {string}
     * @memberof ConfiguratorProductQuickcouplers1
     */
    name: string;
    /**
     * the list of quickcouplers for this system
     * @type {Array&lt;ConfiguratorProductQuickcouplers&gt;}
     * @memberof ConfiguratorProductQuickcouplers1
     */
    quickcouplers: Array<ConfiguratorProductQuickcouplers>;
}

/**
 * a showroom
 * @export
 * @interface ConfiguratorProductShowrooms
 */
export interface ConfiguratorProductShowrooms {
    /**
     * the (short) name of the showroom
     * @type {string}
     * @memberof ConfiguratorProductShowrooms
     */
    name?: string;
    /**
     * description of the showroom
     * @type {Nameml}
     * @memberof ConfiguratorProductShowrooms
     */
    descriptionml?: Nameml;
    /**
     * array containing the language codes (it/de/fr/en/lt/lv/ee/fi) for which this showroom should be displayed.
     * @type {Array&lt;string&gt;}
     * @memberof ConfiguratorProductShowrooms
     */
    languages?: Array<string>;
    /**
     * the url of the showroom
     * @type {string}
     * @memberof ConfiguratorProductShowrooms
     */
    url?: string;
}

/**
 * the discount for a special offer.
 * @export
 * @interface ConfiguratorProductSpecialdiscount
 */
export interface ConfiguratorProductSpecialdiscount {
    /**
     * a link to a image (450x608) describing the special offer
     * @type {string}
     * @memberof ConfiguratorProductSpecialdiscount
     */
    imageurl: string;
    /**
     * a list of documents pertaining this special offer
     * @type {Documents}
     * @memberof ConfiguratorProductSpecialdiscount
     */
    documents?: Documents;
    /**
     * the discount in percentage
     * @type {number}
     * @memberof ConfiguratorProductSpecialdiscount
     */
    percentage: number;
    /**
     * the end date of the discount
     * @type {string}
     * @memberof ConfiguratorProductSpecialdiscount
     */
    enddate: string;
    /**
     * number of pieces remaining. When 0, show the warning about the end of offer, when >0 show remaining quantity
     * @type {number}
     * @memberof ConfiguratorProductSpecialdiscount
     */
    remainingquantity?: number;
}

/**
 * a spinset
 * @export
 * @interface ConfiguratorProductSpinsets
 */
export interface ConfiguratorProductSpinsets {
    /**
     * the type of spinset
     * @type {string}
     * @memberof ConfiguratorProductSpinsets
     */
    type?: ConfiguratorProductSpinsets.TypeEnum;
    /**
     * the url of the spinset
     * @type {string}
     * @memberof ConfiguratorProductSpinsets
     */
    url?: string;
}

/**
 * @export
 * @namespace ConfiguratorProductSpinsets
 */
export namespace ConfiguratorProductSpinsets {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        SPINSETEXTERIOR = <any> 'SPINSETEXTERIOR',
        SPINSETINTERIOR = <any> 'SPINSETINTERIOR'
    }
}

/**
 * multilingual title
 * @export
 * @interface ConfiguratorProductTitleml
 */
export interface ConfiguratorProductTitleml {
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductTitleml
     */
    de?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductTitleml
     */
    en?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductTitleml
     */
    fr?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductTitleml
     */
    it?: string;
}

/**
 * multilingual title
 * @export
 * @interface ConfiguratorProductTitleml1
 */
export interface ConfiguratorProductTitleml1 {
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductTitleml1
     */
    de?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductTitleml1
     */
    en?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductTitleml1
     */
    fr?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductTitleml1
     */
    it?: string;
}

/**
 * 
 * @export
 * @interface ConfiguratorProductTypes
 */
export interface ConfiguratorProductTypes {
    /**
     * identifier of the linkage
     * @type {number}
     * @memberof ConfiguratorProductTypes
     */
    linkageid: number;
    /**
     * the name of the linkage
     * @type {string}
     * @memberof ConfiguratorProductTypes
     */
    linkagename: string;
    /**
     * the list of the option id that are not compatible with this type. This can possible contain options id that are unknown to the configurator.
     * @type {Array&lt;number&gt;}
     * @memberof ConfiguratorProductTypes
     */
    incompatibleoptions: Array<number>;
    /**
     * 
     * @type {ConfiguratorProductPrice2}
     * @memberof ConfiguratorProductTypes
     */
    price: ConfiguratorProductPrice2;
    /**
     * 
     * @type {number}
     * @memberof ConfiguratorProductTypes
     */
    typeid: number;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductTypes
     */
    name: string;
    /**
     * description of the product
     * @type {Nameml}
     * @memberof ConfiguratorProductTypes
     */
    descriptionml: Nameml;
}

/**
 * a series of URLs pointing to the PDF datasheet of this used equipment. The key specifies the language [de|it|fr|en]
 * @export
 * @interface ConfiguratorProductUsedequipmentpdfdatasheeturl
 */
export interface ConfiguratorProductUsedequipmentpdfdatasheeturl {
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductUsedequipmentpdfdatasheeturl
     */
    de?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductUsedequipmentpdfdatasheeturl
     */
    fr?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductUsedequipmentpdfdatasheeturl
     */
    it?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfiguratorProductUsedequipmentpdfdatasheeturl
     */
    en?: string;
}

/**
 * 
 * @export
 * @interface CurrentConfiguration
 */
export interface CurrentConfiguration {
    /**
     * the salesman to be contacted for information about the product - can be null - if this is not null, it must be shown, and the productmanager be hidden
     * @type {AvescoContact}
     * @memberof CurrentConfiguration
     */
    salesman?: AvescoContact;
    /**
     * the customer's contact info. When the customercontact is defined, and the HTTP is PUT, the offer is considered final. I.e. all the notifications will be sent and the purchase/productform id in the cookie will be removed.
     * @type {CustomerContact}
     * @memberof CurrentConfiguration
     */
    customercontact: CustomerContact;
    /**
     * the ID of the selected quickcoupler, can be null
     * @type {number}
     * @memberof CurrentConfiguration
     */
    quickcoupler?: number;
    /**
     * list of IDs of the selected buckets. Can be empty.
     * @type {Array&lt;number&gt;}
     * @memberof CurrentConfiguration
     */
    buckets: Array<number>;
    /**
     * 
     * @type {CurrentConfigurationFullservice}
     * @memberof CurrentConfiguration
     */
    fullservice?: CurrentConfigurationFullservice;
    /**
     * 
     * @type {CurrentConfigurationExtendedwarranty}
     * @memberof CurrentConfiguration
     */
    extendedwarranty?: CurrentConfigurationExtendedwarranty;
    /**
     * maps the category id to the selected options id
     * @type {any}
     * @memberof CurrentConfiguration
     */
    options: any;
    /**
     * language code of the offer [de|it|fr|en]
     * @type {string}
     * @memberof CurrentConfiguration
     */
    languagecode: string;
    /**
     * the price for the current configuration. Filled by the server
     * @type {number}
     * @memberof CurrentConfiguration
     */
    price?: number;
    /**
     * the customer identifier. This is the DBS CALPF001.CUNO field. Filled by the server.
     * @type {string}
     * @memberof CurrentConfiguration
     */
    customerid?: string;
    /**
     * the target currency of the offer. All prices are expressed using this currency
     * @type {string}
     * @memberof CurrentConfiguration
     */
    currency: string;
    /**
     * the id of the offer (matches MoSale Purchase). Can be null if the offer was not yet saved.
     * @type {number}
     * @memberof CurrentConfiguration
     */
    purchaseid?: number;
    /**
     * the id of the productform (matches MoSale Purchase). Can be null if the offer was not yet saved.
     * @type {number}
     * @memberof CurrentConfiguration
     */
    productformid?: number;
    /**
     * the Id of the product
     * @type {number}
     * @memberof CurrentConfiguration
     */
    productid: number;
    /**
     * the id of the machine (typ)
     * @type {number}
     * @memberof CurrentConfiguration
     */
    machineid: number;
    /**
     * 
     * @type {CurrentConfigurationRent}
     * @memberof CurrentConfiguration
     */
    rent?: CurrentConfigurationRent;
    /**
     * 
     * @type {CurrentConfigurationLeasing}
     * @memberof CurrentConfiguration
     */
    leasing?: CurrentConfigurationLeasing;
    /**
     * the effective discount as saved in the offer
     * @type {number}
     * @memberof CurrentConfiguration
     */
    discount?: number;
}

/**
 * the selected extended warranty. Can be null.
 * @export
 * @interface CurrentConfigurationExtendedwarranty
 */
export interface CurrentConfigurationExtendedwarranty {
    /**
     * the extended warranty duration
     * @type {number}
     * @memberof CurrentConfigurationExtendedwarranty
     */
    durationmonths: number;
    /**
     * the warranty type key
     * @type {string}
     * @memberof CurrentConfigurationExtendedwarranty
     */
    warrantytype: string;
    /**
     * the price of the selected configuration in the currency of the offer
     * @type {number}
     * @memberof CurrentConfigurationExtendedwarranty
     */
    price?: number;
}

/**
 * the selected full service. Can be null
 * @export
 * @interface CurrentConfigurationFullservice
 */
export interface CurrentConfigurationFullservice {
    /**
     * the full service duration in months
     * @type {number}
     * @memberof CurrentConfigurationFullservice
     */
    durationmonths: number;
    /**
     * the full service hours per year
     * @type {number}
     * @memberof CurrentConfigurationFullservice
     */
    hoursperyear: number;
    /**
     * the price per month of the selected configuration
     * @type {number}
     * @memberof CurrentConfigurationFullservice
     */
    monthlyrate?: number;
}

/**
 * the leasing parameters or null. leasing and rent are mutually exclusive.
 * @export
 * @interface CurrentConfigurationLeasing
 */
export interface CurrentConfigurationLeasing {
    /**
     * the rent duration in months
     * @type {number}
     * @memberof CurrentConfigurationLeasing
     */
    durationmonths: number;
    /**
     * the initial payment percentage (of price) in %. 
     * @type {number}
     * @memberof CurrentConfigurationLeasing
     */
    initialpaymentpercent: number;
    /**
     * the rate per month of the leasing. Filled by the server.
     * @type {number}
     * @memberof CurrentConfigurationLeasing
     */
    monthlyrate?: number;
}

/**
 * the rent parameters or null
 * @export
 * @interface CurrentConfigurationRent
 */
export interface CurrentConfigurationRent {
    /**
     * the rent duration in months. leasing and rent are mutually exclusive.
     * @type {number}
     * @memberof CurrentConfigurationRent
     */
    durationmonths: number;
    /**
     * the rate per month of the rent. Filled by the server
     * @type {number}
     * @memberof CurrentConfigurationRent
     */
    monthlyrate?: number;
}

/**
 * the customer's contact info.
 * @export
 * @interface CustomerContact
 */
export interface CustomerContact {
    /**
     * true if the anonymous customers wants to join the customers portal. if true the names/phone/email/company fields must be filled out.
     * @type {boolean}
     * @memberof CustomerContact
     */
    newportalaccountrequest?: boolean;
    /**
     * the type of contact - either offer or contract
     * @type {string}
     * @memberof CustomerContact
     */
    contacttype?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    givenname?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    familyname?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    companyname?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    address1?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    address2?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    zipcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    country?: string;
}

/**
 * a array, possibly empty, containing extra documents
 * @export
 * @interface Documents
 */
export interface Documents extends Array<DocumentsInner> {
}

/**
 * a document
 * @export
 * @interface DocumentsInner
 */
export interface DocumentsInner {
    /**
     * array containing the language codes (it/de/fr/en/lt/lv/ee/fi) for which this document should be displayed
     * @type {Array&lt;string&gt;}
     * @memberof DocumentsInner
     */
    languages?: Array<string>;
    /**
     * 
     * @type {DocumentsInnerDescription}
     * @memberof DocumentsInner
     */
    description?: DocumentsInnerDescription;
    /**
     * the relative URL of the document
     * @type {string}
     * @memberof DocumentsInner
     */
    url?: string;
}

/**
 * multilingual description
 * @export
 * @interface DocumentsInnerDescription
 */
export interface DocumentsInnerDescription {
    /**
     * 
     * @type {string}
     * @memberof DocumentsInnerDescription
     */
    de?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentsInnerDescription
     */
    en?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentsInnerDescription
     */
    fr?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentsInnerDescription
     */
    it?: string;
}

/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * Invalid input.
     * @type {string}
     * @memberof ModelError
     */
    error: string;
}

/**
 * multilingual label
 * @export
 * @interface Nameml
 */
export interface Nameml {
    /**
     * text in english
     * @type {string}
     * @memberof Nameml
     */
    en: string;
    /**
     * text in german
     * @type {string}
     * @memberof Nameml
     */
    de?: string;
    /**
     * text in french
     * @type {string}
     * @memberof Nameml
     */
    fr?: string;
    /**
     * text in italian
     * @type {string}
     * @memberof Nameml
     */
    it?: string;
    /**
     * text in lithuanian
     * @type {string}
     * @memberof Nameml
     */
    lt?: string;
    /**
     * text in latvian
     * @type {string}
     * @memberof Nameml
     */
    lv?: string;
    /**
     * text in estonian
     * @type {string}
     * @memberof Nameml
     */
    et?: string;
    /**
     * text in finnish
     * @type {string}
     * @memberof Nameml
     */
    fi?: string;
}

/**
 * a product, with image and with a list of main characteristics
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    id: number;
    /**
     * 
     * @type {Nameml}
     * @memberof Product
     */
    nameml: Nameml;
    /**
     * name of the product family (used for sorting)
     * @type {Nameml}
     * @memberof Product
     */
    productfamilynameml?: Nameml;
    /**
     * a link to a catalogue image. This can return a 404. The client should then provide a placeholder.
     * @type {string}
     * @memberof Product
     */
    iconurl?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    maincharacteristic1id?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    maincharacteristic2id?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    maincharacteristic3id?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    maincharacteristic1value?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    maincharacteristic2value?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    maincharacteristic3value?: string;
    /**
     * 
     * @type {Nameml}
     * @memberof Product
     */
    maincharacteristic1nameml?: Nameml;
    /**
     * 
     * @type {Nameml}
     * @memberof Product
     */
    maincharacteristic2nameml?: Nameml;
    /**
     * 
     * @type {Nameml}
     * @memberof Product
     */
    maincharacteristic3nameml?: Nameml;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    specialoffer?: boolean;
}

/**
 * list of product family icons, already sorted.
 * @export
 * @interface ProductFamilyIcons
 */
export interface ProductFamilyIcons extends Array<ProductFamilyIconsInner> {
}

/**
 * 
 * @export
 * @interface ProductFamilyIconsInner
 */
export interface ProductFamilyIconsInner {
    /**
     * 
     * @type {number}
     * @memberof ProductFamilyIconsInner
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ProductFamilyIconsInner
     */
    pos?: number;
    /**
     * name of the product family icon
     * @type {Nameml}
     * @memberof ProductFamilyIconsInner
     */
    nameml: Nameml;
    /**
     * a URL pointing to the icon. This must always return a valid URL, otherwise it is an internal error.
     * @type {string}
     * @memberof ProductFamilyIconsInner
     */
    iconurl?: string;
}

/**
 * a list of products
 * @export
 * @interface ProductList
 */
export interface ProductList extends Array<Product> {
}

/**
 * 
 * @export
 * @interface SpecialOfferCompactList
 */
export interface SpecialOfferCompactList extends Array<SpecialOfferCompactListInner> {
}

/**
 * a list of special offers
 * @export
 * @interface SpecialOfferCompactListInner
 */
export interface SpecialOfferCompactListInner {
    /**
     * a link to a image (450x608) describing the special offer
     * @type {string}
     * @memberof SpecialOfferCompactListInner
     */
    imageurl: string;
    /**
     * 
     * @type {number}
     * @memberof SpecialOfferCompactListInner
     */
    id: number;
    /**
     * type of special offer. Either TabletSpecialOffer or ConfiguratorSpecialOffer. For debugging purposes
     * @type {string}
     * @memberof SpecialOfferCompactListInner
     */
    type: string;
    /**
     * a list of documents pertaining this special offer
     * @type {Documents}
     * @memberof SpecialOfferCompactListInner
     */
    documents: Documents;
    /**
     * 
     * @type {ProductList}
     * @memberof SpecialOfferCompactListInner
     */
    products: ProductList;
    /**
     * a short title for the special offer
     * @type {Nameml}
     * @memberof SpecialOfferCompactListInner
     */
    nameml: Nameml;
    /**
     * a possibly long description for the special offer
     * @type {Nameml}
     * @memberof SpecialOfferCompactListInner
     */
    descriptionml: Nameml;
}

/**
 * 
 * @export
 * @interface Success
 */
export interface Success {
    /**
     * Successful operation.
     * @type {string}
     * @memberof Success
     */
    memberID: string;
}

/**
 * 
 * @export
 * @interface UsedMainCategories
 */
export interface UsedMainCategories extends Array<UsedMainCategoriesInner> {
}

/**
 * 
 * @export
 * @interface UsedMainCategoriesInner
 */
export interface UsedMainCategoriesInner {
    /**
     * 
     * @type {number}
     * @memberof UsedMainCategoriesInner
     */
    id: number;
    /**
     * name of the main category
     * @type {Nameml}
     * @memberof UsedMainCategoriesInner
     */
    nameml: Nameml;
    /**
     * a link to the icon, this must always return a valid URL
     * @type {string}
     * @memberof UsedMainCategoriesInner
     */
    iconurl?: string;
}


/**
 * DefaultApi - fetch parameter creator
 * @export
 */
export const DefaultApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary given the product id, redirects (302) to the right hierarchy with a relative URL.
         * @param {number} productid the product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkToProduct(productid: number, options: any = {}): FetchArgs {
            // verify required parameter 'productid' is not null or undefined
            if (productid === null || productid === undefined) {
                throw new RequiredError('productid','Required parameter productid was null or undefined when calling linkToProduct.');
            }
            const localVarPath = `/linktoproduct`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productid !== undefined) {
                localVarQueryParameter['productid'] = productid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary logs the current user out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options: any = {}): FetchArgs {
            const localVarPath = `/logout`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary submits the request for a new portal account.
         * @param {CustomerContact} [customerContact] the customers contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newPortalAccountRequest(customerContact?: CustomerContact, options: any = {}): FetchArgs {
            const localVarPath = `/newportalaccountrequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CustomerContact" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(customerContact || {}) : (customerContact || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary removes the configurator JWT cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeConfiguratorJWTCookie(options: any = {}): FetchArgs {
            const localVarPath = `/unsetconfiguratorcookie`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves all used main categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllUsedMainCategories(options: any = {}): FetchArgs {
            const localVarPath = `/usedmaincategories`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves a configuration, containing the updates costs. Expensive operation.
         * @param {number} purchaseid the numeric identifier of the purchase
         * @param {number} productformid the numberic identified of the productform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveConfiguration(purchaseid: number, productformid: number, options: any = {}): FetchArgs {
            // verify required parameter 'purchaseid' is not null or undefined
            if (purchaseid === null || purchaseid === undefined) {
                throw new RequiredError('purchaseid','Required parameter purchaseid was null or undefined when calling retrieveConfiguration.');
            }
            // verify required parameter 'productformid' is not null or undefined
            if (productformid === null || productformid === undefined) {
                throw new RequiredError('productformid','Required parameter productformid was null or undefined when calling retrieveConfiguration.');
            }
            const localVarPath = `/configuration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (purchaseid !== undefined) {
                localVarQueryParameter['purchaseid'] = purchaseid;
            }

            if (productformid !== undefined) {
                localVarQueryParameter['productformid'] = productformid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves the initial JSON to configure a given product
         * @param {number} id the numeric identifier of the product to configure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveConfiguratorProduct(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling retrieveConfiguratorProduct.');
            }
            const localVarPath = `/configuratorproduct`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves all PFI tied to a used main category
         * @param {number} usedmaincategoryid the used main category id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePfiByUsedMainCategory(usedmaincategoryid: number, options: any = {}): FetchArgs {
            // verify required parameter 'usedmaincategoryid' is not null or undefined
            if (usedmaincategoryid === null || usedmaincategoryid === undefined) {
                throw new RequiredError('usedmaincategoryid','Required parameter usedmaincategoryid was null or undefined when calling retrievePfiByUsedMainCategory.');
            }
            const localVarPath = `/productfamilyicons`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (usedmaincategoryid !== undefined) {
                localVarQueryParameter['usedmaincategoryid'] = usedmaincategoryid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves all products tied to a ProductFamilyIcon
         * @param {number} productfamilyiconid the ProductFamilyIcon id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveProductsByProductFamilyIcon(productfamilyiconid: number, options: any = {}): FetchArgs {
            // verify required parameter 'productfamilyiconid' is not null or undefined
            if (productfamilyiconid === null || productfamilyiconid === undefined) {
                throw new RequiredError('productfamilyiconid','Required parameter productfamilyiconid was null or undefined when calling retrieveProductsByProductFamilyIcon.');
            }
            const localVarPath = `/productsofproductfamilyicon`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productfamilyiconid !== undefined) {
                localVarQueryParameter['productfamilyiconid'] = productfamilyiconid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves the special offers to be displayed on the main/start/root page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersCompactOverview(options: any = {}): FetchArgs {
            const localVarPath = `/specialofferscompactoverview`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves the special offers to be displayed on the main/start/root page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersOverview(options: any = {}): FetchArgs {
            const localVarPath = `/specialoffersoverview`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary submits a configuration for insertion/update. Returns an updated version. Expensive operation.
         * @param {CurrentConfiguration} [currentConfiguration] the configuration to update/insert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitConfiguration(currentConfiguration?: CurrentConfiguration, options: any = {}): FetchArgs {
            const localVarPath = `/configuration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CurrentConfiguration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(currentConfiguration || {}) : (currentConfiguration || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary given the product id, redirects (302) to the right hierarchy with a relative URL.
         * @param {number} productid the product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkToProduct(productid: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).linkToProduct(productid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary logs the current user out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).logout(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary submits the request for a new portal account.
         * @param {CustomerContact} [customerContact] the customers contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newPortalAccountRequest(customerContact?: CustomerContact, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).newPortalAccountRequest(customerContact, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary removes the configurator JWT cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeConfiguratorJWTCookie(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).removeConfiguratorJWTCookie(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary retrieves all used main categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllUsedMainCategories(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UsedMainCategories> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).retrieveAllUsedMainCategories(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary retrieves a configuration, containing the updates costs. Expensive operation.
         * @param {number} purchaseid the numeric identifier of the purchase
         * @param {number} productformid the numberic identified of the productform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveConfiguration(purchaseid: number, productformid: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CurrentConfiguration> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).retrieveConfiguration(purchaseid, productformid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary retrieves the initial JSON to configure a given product
         * @param {number} id the numeric identifier of the product to configure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveConfiguratorProduct(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConfiguratorProduct> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).retrieveConfiguratorProduct(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary retrieves all PFI tied to a used main category
         * @param {number} usedmaincategoryid the used main category id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePfiByUsedMainCategory(usedmaincategoryid: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductFamilyIcons> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).retrievePfiByUsedMainCategory(usedmaincategoryid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary retrieves all products tied to a ProductFamilyIcon
         * @param {number} productfamilyiconid the ProductFamilyIcon id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveProductsByProductFamilyIcon(productfamilyiconid: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductList> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).retrieveProductsByProductFamilyIcon(productfamilyiconid, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary retrieves the special offers to be displayed on the main/start/root page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersCompactOverview(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SpecialOfferCompactList> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).specialOffersCompactOverview(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary retrieves the special offers to be displayed on the main/start/root page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersOverview(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductList> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).specialOffersOverview(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary submits a configuration for insertion/update. Returns an updated version. Expensive operation.
         * @param {CurrentConfiguration} [currentConfiguration] the configuration to update/insert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitConfiguration(currentConfiguration?: CurrentConfiguration, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CurrentConfiguration> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).submitConfiguration(currentConfiguration, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary given the product id, redirects (302) to the right hierarchy with a relative URL.
         * @param {number} productid the product id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkToProduct(productid: number, options?: any) {
            return DefaultApiFp(configuration).linkToProduct(productid, options)(fetch, basePath);
        },
        /**
         * 
         * @summary logs the current user out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any) {
            return DefaultApiFp(configuration).logout(options)(fetch, basePath);
        },
        /**
         * 
         * @summary submits the request for a new portal account.
         * @param {CustomerContact} [customerContact] the customers contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newPortalAccountRequest(customerContact?: CustomerContact, options?: any) {
            return DefaultApiFp(configuration).newPortalAccountRequest(customerContact, options)(fetch, basePath);
        },
        /**
         * 
         * @summary removes the configurator JWT cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeConfiguratorJWTCookie(options?: any) {
            return DefaultApiFp(configuration).removeConfiguratorJWTCookie(options)(fetch, basePath);
        },
        /**
         * 
         * @summary retrieves all used main categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllUsedMainCategories(options?: any) {
            return DefaultApiFp(configuration).retrieveAllUsedMainCategories(options)(fetch, basePath);
        },
        /**
         * 
         * @summary retrieves a configuration, containing the updates costs. Expensive operation.
         * @param {number} purchaseid the numeric identifier of the purchase
         * @param {number} productformid the numberic identified of the productform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveConfiguration(purchaseid: number, productformid: number, options?: any) {
            return DefaultApiFp(configuration).retrieveConfiguration(purchaseid, productformid, options)(fetch, basePath);
        },
        /**
         * 
         * @summary retrieves the initial JSON to configure a given product
         * @param {number} id the numeric identifier of the product to configure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveConfiguratorProduct(id: number, options?: any) {
            return DefaultApiFp(configuration).retrieveConfiguratorProduct(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary retrieves all PFI tied to a used main category
         * @param {number} usedmaincategoryid the used main category id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePfiByUsedMainCategory(usedmaincategoryid: number, options?: any) {
            return DefaultApiFp(configuration).retrievePfiByUsedMainCategory(usedmaincategoryid, options)(fetch, basePath);
        },
        /**
         * 
         * @summary retrieves all products tied to a ProductFamilyIcon
         * @param {number} productfamilyiconid the ProductFamilyIcon id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveProductsByProductFamilyIcon(productfamilyiconid: number, options?: any) {
            return DefaultApiFp(configuration).retrieveProductsByProductFamilyIcon(productfamilyiconid, options)(fetch, basePath);
        },
        /**
         * 
         * @summary retrieves the special offers to be displayed on the main/start/root page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersCompactOverview(options?: any) {
            return DefaultApiFp(configuration).specialOffersCompactOverview(options)(fetch, basePath);
        },
        /**
         * 
         * @summary retrieves the special offers to be displayed on the main/start/root page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialOffersOverview(options?: any) {
            return DefaultApiFp(configuration).specialOffersOverview(options)(fetch, basePath);
        },
        /**
         * 
         * @summary submits a configuration for insertion/update. Returns an updated version. Expensive operation.
         * @param {CurrentConfiguration} [currentConfiguration] the configuration to update/insert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitConfiguration(currentConfiguration?: CurrentConfiguration, options?: any) {
            return DefaultApiFp(configuration).submitConfiguration(currentConfiguration, options)(fetch, basePath);
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary given the product id, redirects (302) to the right hierarchy with a relative URL.
     * @param {} productid the product id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public linkToProduct(productid: number, options?: any) {
        return DefaultApiFp(this.configuration).linkToProduct(productid, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary logs the current user out
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public logout(options?: any) {
        return DefaultApiFp(this.configuration).logout(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary submits the request for a new portal account.
     * @param {} [customerContact] the customers contact data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public newPortalAccountRequest(customerContact?: CustomerContact, options?: any) {
        return DefaultApiFp(this.configuration).newPortalAccountRequest(customerContact, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary removes the configurator JWT cookie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeConfiguratorJWTCookie(options?: any) {
        return DefaultApiFp(this.configuration).removeConfiguratorJWTCookie(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary retrieves all used main categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public retrieveAllUsedMainCategories(options?: any) {
        return DefaultApiFp(this.configuration).retrieveAllUsedMainCategories(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary retrieves a configuration, containing the updates costs. Expensive operation.
     * @param {} purchaseid the numeric identifier of the purchase
     * @param {} productformid the numberic identified of the productform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public retrieveConfiguration(purchaseid: number, productformid: number, options?: any) {
        return DefaultApiFp(this.configuration).retrieveConfiguration(purchaseid, productformid, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary retrieves the initial JSON to configure a given product
     * @param {} id the numeric identifier of the product to configure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public retrieveConfiguratorProduct(id: number, options?: any) {
        return DefaultApiFp(this.configuration).retrieveConfiguratorProduct(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary retrieves all PFI tied to a used main category
     * @param {} usedmaincategoryid the used main category id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public retrievePfiByUsedMainCategory(usedmaincategoryid: number, options?: any) {
        return DefaultApiFp(this.configuration).retrievePfiByUsedMainCategory(usedmaincategoryid, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary retrieves all products tied to a ProductFamilyIcon
     * @param {} productfamilyiconid the ProductFamilyIcon id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public retrieveProductsByProductFamilyIcon(productfamilyiconid: number, options?: any) {
        return DefaultApiFp(this.configuration).retrieveProductsByProductFamilyIcon(productfamilyiconid, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary retrieves the special offers to be displayed on the main/start/root page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public specialOffersCompactOverview(options?: any) {
        return DefaultApiFp(this.configuration).specialOffersCompactOverview(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary retrieves the special offers to be displayed on the main/start/root page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public specialOffersOverview(options?: any) {
        return DefaultApiFp(this.configuration).specialOffersOverview(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary submits a configuration for insertion/update. Returns an updated version. Expensive operation.
     * @param {} [currentConfiguration] the configuration to update/insert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitConfiguration(currentConfiguration?: CurrentConfiguration, options?: any) {
        return DefaultApiFp(this.configuration).submitConfiguration(currentConfiguration, options)(this.fetch, this.basePath);
    }

}




// WEBPACK FOOTER //
// ./src/services/api.ts